import { useQuery } from '@tanstack/react-query';

import { QuizKey } from './keys';
import { QuizService } from './quizService';

export function useGetAssignedQuizzes(name?: string) {
  return useQuery({
    queryKey: [QuizKey.ASSIGNED_QUIZZES, name],
    queryFn: () => QuizService.getAssignedQuizzes().then((response) => response.data),
  });
}
